export default {
  props: {
    config: {
      type: Object,
      default: () => {},
    },
  },
  provide() {
    return {
      config: this.config,
    };
  },
};
